import * as React from 'react';
import { connect } from 'react-redux';

import {
  Button,
  createStyles,
  Divider,
  Theme,
  Typography,
  WithStyles,
  withStyles
} from '@material-ui/core';

import * as LieuucationActions from '@actions/LieuucationActions';
import * as UserActions from '@actions/UserActions';
import { IStore, IUserState } from '@reducers';

import LieuucationReport from '@components/Lieuucation/LieuucationReport';

import { getFreeReportId } from '@lieuu/core';

const styles = (theme: Theme) =>
  createStyles({
    container: {
      marginBottom: theme.spacing(1),
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    callToActionContainer: {
      marginRight: theme.spacing(30),

      [theme.breakpoints.down('sm')]: {
        marginRight: theme.spacing(7)
      },
      padding: theme.spacing(1)
    },
    divider: {
      marginBottom: theme.spacing(4)
    },
    mainSubtitleDetail: {
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: theme.breakpoints.values.sm
    },
    callToActionButton: {
      width: '100%',
      textAlign: 'center',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(10)
    }
  });

const mapDispatchToProps = {
  toggleAuthModal: UserActions.toggleAuthModal,
  getLieuucationById: LieuucationActions.getLieuucationById.request
};

type IProps = IUserState &
  typeof mapDispatchToProps &
  WithStyles<typeof styles>;

const SampleReportPage: React.FC<IProps> = ({
  getLieuucationById,
  toggleAuthModal,
  classes
}) => {
  const [freeReportId] = React.useState(getFreeReportId());

  React.useEffect(() => {
    getLieuucationById({ id: freeReportId });
  }, [freeReportId]);

  const signUp = () =>
    toggleAuthModal({
      showModal: 'signup'
    });

  return (
    <>
      <div className={classes.container}>
        <LieuucationReport
          isExampleReport={true}
          lieuucationId={freeReportId}
        />
        <Divider className={classes.divider} />
        <div className={classes.callToActionContainer}>
          <Typography variant="h4" align="center" gutterBottom>
            Redefine your property search
          </Typography>
          <Typography
            className={classes.mainSubtitleDetail}
            variant="h6"
            align="center"
            gutterBottom
          >
            Change the way you research with micromarket analytics and
            investor-grade data on every neighborhood in the US.
          </Typography>
          <div className={classes.callToActionButton}>
            <Button
              onClick={signUp}
              variant="contained"
              color="secondary"
              size="large"
            >
              {'Sign up to view reports for free'}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default withStyles(styles)(
  connect(
    (state: IStore): IUserState => state.user,
    mapDispatchToProps
  )(SampleReportPage)
);
